import React from 'react'

import { Select, MenuItem } from '@material-ui/core'

import { DatePicker } from '@material-ui/pickers';

import PeriodFilterPicker from '../PeriodPicker/PeriodFilterPicker'
import { PERIOD_BOUNDS } from '../PeriodPicker/usePeriodBounds'
import {getTranslationEntry, getStateTranslationEntry} from '../../translations/Utils'
import TranslationProvider from '../../translations/TranslationProvider'
import { parsePlainDate, toPlainDateString } from '../../utils/DateUtils';

import {
    CustomTableCellInput,
    CustomOutlinedInput,
    CustomOutlinedDropdownInput,
    FilterDatePickerTextField,
    NullTextFilterComponent
} from './BPMComponents';

function SelectFilterComponent(props) {
    const {id, filters, options, onChange, customKey} = props

    const handleChange = (callback, e, t) => {
        const allState = getStateTranslationEntry("ALL");
        const filterAll = options.optionals.all || allState;
        // eslint-disable-next-line eqeqeq
        if(e.target.value == filterAll ){
            e.target.value = ""
        }
        callback(e)
    }

    return(
        <TranslationProvider key={"tprov_" + customKey}>
            {t => (
                <CustomTableCellInput  key={"cell" + customKey}  style={{fontSize:16}}>
                    <Select
                        name={id}
                        padding="checkbox"
                        onChange={(e) => handleChange(onChange, e, t)}
                        // eslint-disable-next-line eqeqeq
                        value={filters[id] != undefined ? filters[id] : (options.optionals.all || "ALL")}
                        style={{width:'100%',textAlign: 'center',fontWeight: 'bold'}}
                        input={<CustomOutlinedDropdownInput labelWidth={0} style={{color:"white",paddingLeft:5}}/> }
                    >
                        <MenuItem value={options.optionals.all } key={options.optionals.all }>
                            {options.optionals.all }
                        </MenuItem>
                        {options.filters.map(option =>
                            <MenuItem value={option.value} key={option.value}> {option.label} </MenuItem>
                        )}
                    </Select>
                </CustomTableCellInput>
            )}
        </TranslationProvider>
    )
}

class Filter {
    constructor(id){
        this.id = id;
    }

    getVariableType(){
        throw new Error("You must implement the getVariableType method");
    }
}

class TextFilter extends Filter{
    getVariableType(){
        return 'String';
    }

    filterCreator(props){
        return(
            <TranslationProvider key={"tprov_" + props.key}>
                { t => (
                    <CustomTableCellInput  key={"cell" + props.key}  style={{fontSize:16}}>
                        <CustomOutlinedInput
                            labelWidth={0}
                            autoComplete='off'
                            placeholder={t('placeholder:Filter')}
                            onChange={props.onChange}
                            value={props.filters[this.id] || ""}
                            style={{width:'100%',fontSize:15}}
                            name={this.id}
                        />
                </CustomTableCellInput>
                )}
            </TranslationProvider>
        )
    }
}

class NullTextFilter extends Filter{
    getVariableType(){
        return 'String';
    }

    filterCreator(props) {
        return (
            <NullTextFilterComponent
                key={props.key}
                onChange={props.onChange}
                value={props.filters[this.id] || ""}
                id={this.id}
            />
        )
    }
}

/**
 * Filters a date, datetime or period column by year-month, emitting "YYYY-MM".
 *
 * Bounds are opt-in via `{bounds}`: pass a PERIOD_BOUNDS source only for columns
 * whose value really is one of the company's periods. Date columns must stay
 * unbounded — contract end dates, terminations and audit timestamps all fall
 * outside the published period range.
 */
class PeriodFilter extends Filter{
    constructor(id, {bounds} = {}){
        super(id);
        this.bounds = bounds;
    }

    getVariableType(){
        return 'String';
    }

    filterCreator(props) {
        return (
            <CustomTableCellInput key={'cell' + props.key} style={{fontSize: 16}}>
                <PeriodFilterPicker
                    name={this.id}
                    filterId={this.id}
                    filters={props.filters}
                    onChangeDate={props.onChange}
                    bounds={this.bounds}
                />
            </CustomTableCellInput>
        )
    }
}

class DateFilter extends Filter{
    getVariableType(){
        return 'String';
    }

    filterCreator(props){
    const currentValue = toPlainDateString(props.filters[this.id]) || '';
    const dateValue = currentValue ? parsePlainDate(currentValue) : null;
    const handleChange = date => {
      props.onChange({ target: { name: this.id, value: toPlainDateString(date) || '' } });
    };

        return(
      <CustomTableCellInput key={'cell' + props.key} style={{ fontSize: 16 }}>
        <DatePicker
          autoOk
          clearable
          value={dateValue}
          onChange={handleChange}
          format='P'
          inputVariant='outlined'
          TextFieldComponent={FilterDatePickerTextField}
                />
            </CustomTableCellInput>
        )
    }
}

class BooleanFilter extends Filter{
    constructor(id, labelTrue="Active", labelFalse="Inactive"){
        super(id);
        this.labelTrue = labelTrue;
        this.labelFalse = labelFalse;
    }

    getVariableType(){
        return 'Boolean';
    }

    filterCreator(props){
       return (
            <SelectFilterComponent
                id={this.id}
                key={this.id}
                customKey={this.id}
                onChange={props.onChange}
                filters={props.filters}
                options={
                    {
                        filters:[
                            {label: getStateTranslationEntry(this.labelTrue), value: true},
                            {label: getStateTranslationEntry(this.labelFalse), value: false}
                        ], optionals: {all: getStateTranslationEntry('ALL')}
                    }
                }
            />
       )
    }
}

class LanguageFilter extends Filter{
    getVariableType(){
        return 'String';
    }

    filterCreator(props){
        return (
            <SelectFilterComponent
                id={this.id}
                key={this.id}
                customKey={this.id}
                onChange={props.onChange}
                filters={props.filters}
                options={
                    {
                        filters:[
                            {label: getStateTranslationEntry('PORTUGUESE'), value: 'pt'},
                            {label: getStateTranslationEntry('SPANISH'), value: 'es'},
                            {label: getStateTranslationEntry('ENGLISH'), value: 'en'}
                        ], optionals: {all: getStateTranslationEntry('ALL')}
                    }
                }
            />
        )
    }
}

class InvoicePaymentStateFilter extends Filter{
    getVariableType(){
        return 'String';
    }

    filterCreator(props){
        return (
            <SelectFilterComponent
                id={this.id}
                key={this.id}
                customKey={this.id}
                onChange={props.onChange}
                filters={props.filters}
                options={
                    {
                        filters:[
                            {label: getStateTranslationEntry('AVAILABLE'), value: '0'},
                            {label: getStateTranslationEntry('ASSIGNED'), value: '1'},
                            {label: getStateTranslationEntry('CLOSED'), value: '2'}
                        ], optionals: {all: getStateTranslationEntry("ALL")}
                    }
                }
            />
        )
     }
}


class InvoicePaymentGroupStateFilter extends Filter{
    getVariableType(){
        return 'String';
    }

    filterCreator(props){
        return (
            <SelectFilterComponent
                id={this.id}
                key={this.id}
                customKey={this.id}
                onChange={props.onChange}
                filters={props.filters}
                options={
                    {
                        filters:[
                            {label: getStateTranslationEntry('PENDING'), value: '0'},
                            {label:  getStateTranslationEntry('PROCESSING'), value: '1'},
                            {label: getStateTranslationEntry('READY'), value: '2'},
                            {label: getStateTranslationEntry('CLOSED'), value: '3'}
                        ], optionals: {all: getStateTranslationEntry("ALL")}
                    }
                }
            />
        )
     }
}

class InvoiceStateFilter extends Filter{
    getVariableType(){
        return 'String';
    }

    filterCreator(props){
       return (
            <SelectFilterComponent
                id={this.id}
                key={this.id}
                customKey={this.id}
                onChange={props.onChange}
                filters={props.filters}
                options={
                    {
                        filters:[
                            {label: getStateTranslationEntry('PENDING'), value: '0'},
                            {label:  getStateTranslationEntry('VALIDATED'), value: '1'},
                        ], optionals: {all: getStateTranslationEntry("ALL")}
                    }
                }
            />
       )
    };
}

class ProcessControlStateFilter extends Filter{
    getVariableType(){
        return 'String';
    }

    filterCreator(props){
        return (
            <SelectFilterComponent
                id={this.id}
                key={this.id}
                customKey={this.id}
                onChange={props.onChange}
                filters={props.filters}
                options={
                    {
                        filters:[
                            {label: getStateTranslationEntry('NOT_STARTED'), value: 'NOT_STARTED'},
                            {label:  getStateTranslationEntry('IN_PROCESS'), value: 'IN_PROCESS'},
                            {label: getStateTranslationEntry('FAILED'), value: 'FAILED'},
                            {label: getStateTranslationEntry('FINISHED'), value: 'FINISHED'},
                        ], optionals: {all: getStateTranslationEntry("ALL")}
                    }
                }
            />
        )
    };
}

class UsersRoleFilter extends Filter{
    getVariableType(){
        return 'String';
    }

    filterCreator(props){
        return (
            <SelectFilterComponent
                id={this.id}
                key={this.id}
                customKey={this.id}
                onChange={props.onChange}
                filters={props.filters}
                options={
                    {
                        filters:[
                            {label: getTranslationEntry('Normal', 'userRole'), value: "Normal"},
                            {label: getTranslationEntry('Manager', 'userRole'), value: "Manager"}
                        ], optionals: {all: getStateTranslationEntry("ALL")}
                    }
                }
            />
        )
    }
}


class TraficClassFilter extends Filter{
    getVariableType(){
        return 'String';
    }

    filterCreator(props){
        return (
            <SelectFilterComponent
                id={this.id}
                key={this.id}
                customKey={this.id}
                onChange={props.onChange}
                filters={props.filters}
                options={
                    {filters:[
                            {label: getTranslationEntry('Domestic', 'traficClassFilter'), value: "Domestic"},
                            {label: getTranslationEntry('Roaming', 'traficClassFilter'), value: "Roaming"}
                        ], optionals: {all: getStateTranslationEntry("ALL")}
                    }
                }
            />
        )
    }
}


class PeriodStateFilter extends Filter{
    getVariableType(){
        return 'String';
    }

    filterCreator(props) {
        return (
            <SelectFilterComponent
                id={this.id}
                key={this.id}
                customKey={this.id}
                onChange={props.onChange}
                filters={props.filters}
                options={
                    {
                        filters:[
                            {label: ' - ', value: null},
                            {label: getStateTranslationEntry('Processed'), value: "1"},
                            {label: getStateTranslationEntry('Cleared'), value: "0"},
                        ], optionals: {all: getStateTranslationEntry("ALL")}
                    }
                }
            />
        )
     }
}

export {
    PERIOD_BOUNDS,
    TextFilter,
    NullTextFilter,
    DateFilter,
    PeriodFilter,
    BooleanFilter,
    LanguageFilter,
    InvoicePaymentStateFilter,
    InvoicePaymentGroupStateFilter,
    InvoiceStateFilter,
    ProcessControlStateFilter,
    UsersRoleFilter,
    TraficClassFilter,
    PeriodStateFilter
}